export enum EPlanificationStatus {
  GOOD = 'GOOD',
  NORMAL = 'NORMAL',
  BAD = 'BAD'
}
